var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgButtonStock = function SvgButtonStock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13.93 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "button_stock")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0h6c.71,0,.91.21.91.93V2.52c0,.58-.18.81-.74.85-.33,0-.26.22-.26.4v7.42c0,.57-.25.81-.82.81H1.8A.69.69,0,0,1,1,11.21V3.88c0-.31,0-.52-.41-.52A.61.61,0,0,1,0,2.71q0-1,0-2C0,.25.29,0,.78,0H7ZM7,6.13H9.86c.26,0,.38-.09.38-.36,0-.49,0-1,0-1.47,0-.27-.12-.36-.39-.36H4.08c-.27,0-.38.1-.37.37,0,.46,0,.92,0,1.38s.14.45.47.44C5.1,6.12,6,6.13,7,6.13Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonStock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/button_stock.9fded444.svg";
export { ForwardRef as ReactComponent };